module.exports = __webpack_public_path__ + "0f9fbaeba7bab4b056ce0cfc52b6b76e.svg";